export default __webpack_public_path__ + "static/media/may2024-1.7d99426a.jpg";